import { GovIcon } from '@gov-design-system-ce/react';
import { useExtraConfigContext } from '@gov-nx/core/app';
import { useLocale } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { Button, FormSearch, FormWidthElementLayout } from '@gov-nx/ui/web';

export const Filters = () => {
	const { code, controls, myFilesFilters, onSubmit } =
		useMojeSouborySeznamContext();
	const { t } = useLocale(code);
	const {
		extraConfig: {
			pageRoutes: { myFilesConfig },
		},
	} = useExtraConfigContext();

	return (
		<>
			<FormWidthElementLayout
				type="l"
				className="relative">
				<FormSearch
					input={{
						field: {
							name: 'text',
							isDisabled: controls.processLoading,
							placeholder: t('formular.placeholder.vyhledat-soubor'),
							...(myFilesConfig.submitOnClear && {
								onChange: (event) => {
									if (event.target.value === '') {
										onSubmit();
									}
								},
							}),
						},
						label: {
							children: t('formular.pole.wcag.vyhledat-soubor'),
						},
					}}
					button={{
						'aria-label': t('akce.vyhledat'),
					}}
				/>
			</FormWidthElementLayout>
			<div>
				<Button
					onClick={myFilesFilters.filterWindowOpened.setTrue}
					color="primary"
					type="outlined"
					size="m"
					aria-label={t('akce.wcag.zobrazit-filtr')}>
					<GovIcon
						name="funnel"
						type="templates"
					/>
				</Button>
			</div>
		</>
	);
};
